import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';

export default function FaqTeaser() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const list = faqs.slice(0, 3);

  return (
    <section aria-labelledby="faq-heading" className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="reveal lg:col-span-4">
          <span className="text-xs font-semibold font-label uppercase tracking-widest text-secondary-600">
            Reader Questions
          </span>
          <h2 id="faq-heading" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            读者最常问的几个问题
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于我们怎么选案例、怎么核实、怎么处理涉事人物信息，这里先回答最常见的三个。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium font-label text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部问题
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="reveal lg:col-span-8">
          <div className="flex flex-col gap-3">
            {list.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.question}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    isOpen ? 'border-primary-300 bg-primary-50/60' : 'border-background-300 bg-background-50'
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 p-5 text-left"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {item.question}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true" />
                    </span>
                  </button>
                  {isOpen ? (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}